import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  const handleClick = (url: string) => {
    window.open(url, '_blank', 'noopener,nofollow');
  };

  return (
    <section id="categories" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-3">
            Wszystkie kategorie Kakobuy Spreadsheet
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            Kliknij dowolną kategorię, aby przejść bezpośrednio do produktów na platformie Kakobuy.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <button
              key={cat.name}
              onClick={() => handleClick(cat.url)}
              className="group flex flex-col items-center bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-300 hover:shadow-sm transition-all cursor-pointer overflow-hidden"
            >
              <div className="relative w-full h-32 sm:h-36 overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
                <div className="absolute bottom-2 left-2 flex items-center gap-1.5">
                  <span className="w-6 h-6 flex items-center justify-center bg-background-50/90 backdrop-blur-sm rounded-md">
                    <i className={`${cat.icon} text-xs text-primary-500`}></i>
                  </span>
                </div>
              </div>
              <div className="px-3 py-3 w-full text-center">
                <span className="text-xs md:text-sm font-medium text-foreground-700 group-hover:text-primary-600 transition-colors leading-tight">
                  {cat.name}
                </span>
              </div>
            </button>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer no-underline"
          >
            <i className="ri-shopping-cart-line"></i>
            Zobacz wszystkie produkty
          </a>
        </div>
      </div>
    </section>
  );
}